import { ALIGN_STATUS } from "@/lib/assessments";
import { cn } from "@/lib/utils";

export function AlignmentBreakdown({ alignment }) {
  return (
    <section className="panel space-y-4 p-5" data-testid="alignment-breakdown">
      <div className="flex items-baseline justify-between">
        <h3 className="text-base font-semibold">Personality alignment with the role</h3>
        <span className="font-display text-3xl font-semibold tabular-nums" data-testid="alignment-score">{alignment.score ?? "—"}</span>
      </div>
      {!alignment.traits.length && <p className="text-sm text-ink-muted">This job has no ideal profile traits that map to the questionnaire.</p>}
      {alignment.traits.map((t) => {
        const [label, cls] = ALIGN_STATUS[t.status];
        return (
          <div key={t.trait} className="space-y-1" data-testid={`align-${t.trait.toLowerCase().replace(/\s+/g, "-")}`}>
            <div className="flex items-center justify-between gap-2 text-sm">
              <span className="text-ink">{t.trait} <span className="text-xs text-ink-muted">· {t.importance} importance</span></span>
              <span className={cn("rounded-full border px-2 py-0.5 text-[11px] font-medium", cls)}>{label}</span>
            </div>
            <div className="relative h-2.5 rounded-full bg-[#EFEBE3]">
              <div className="absolute inset-y-0 rounded-full bg-[#F6EEDC]" style={{ left: `${t.min}%`, width: `${t.max - t.min}%` }} />
              <div className="absolute top-1/2 h-3.5 w-3.5 -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-white bg-brand shadow" style={{ left: `${t.value}%` }} />
            </div>
            <p className="text-[11px] text-ink-muted tabular-nums">Score {t.value} · ideal {t.min}–{t.max}</p>
          </div>
        );
      })}
    </section>
  );
}
